import SupraLockbox from '@bb/domain/dist/types/SupraLockbox';
import Tag from 'components/Tag';
import React from 'react';
import styled from 'styled-components';

const LockboxStatusTag: React.FC<{
  lockboxStatus?: SupraLockbox['lockboxStatus'];
}> = ({ lockboxStatus }) => {
  if (lockboxStatus) {
    const statusColorMap: Record<string, string> = {
      Assigned: 'green',
      Lost: 'orange',
      Defective: 'red',
      Used: 'cyan',
    };
    return (
      <StyledTag color={statusColorMap[lockboxStatus] ?? 'blue'}>
        {lockboxStatus}
      </StyledTag>
    );
  }

  return null;
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default LockboxStatusTag;
